var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "FieldSurvey" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.FieldSurvey.FieldSurveyDefinitions"),
                    active: !_vm.developmentMode
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisTypeId",
                            error: _vm.$v.form.AnalysisTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Label",
                              "lookup-key": "FIELD_SURVEY_TYPE",
                              disabled: _vm.insertReadonly.AnalysisTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisType,
                              callback: function($$v) {
                                _vm.analysisType = $$v
                              },
                              expression: "analysisType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ValidityTypeId",
                            error: _vm.$v.form.ValidityTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Label",
                              "lookup-key": "ANALYSIS_VALIDITY_TYPE",
                              disabled: _vm.insertReadonly.ValidityTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ValidityTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.validityType,
                              callback: function($$v) {
                                _vm.validityType = $$v
                              },
                              expression: "validityType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Description1",
                            error: _vm.$v.form.Description1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.form.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Description1", $$v)
                              },
                              expression: "form.Description1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SortOrder",
                            error: _vm.$v.form.SortOrder
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              min: "0",
                              max: "99",
                              type: "number",
                              disabled: _vm.insertReadonly.SortOrder
                            },
                            on: { input: _vm.changeSortOrder },
                            model: {
                              value: _vm.form.SortOrder,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SortOrder", $$v)
                              },
                              expression: "form.SortOrder"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveStateId",
                            error: _vm.$v.form.ApproveStateId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Label",
                              "lookup-key": "APPROVE_STATE",
                              disabled: _vm.insertReadonly.ApproveStateId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ApproveStateId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedApproveState,
                              callback: function($$v) {
                                _vm.selectedApproveState = $$v
                              },
                              expression: "selectedApproveState"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsNecessary",
                            error: _vm.$v.form.IsNecessary
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.IsNecessary,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsNecessary", $$v)
                              },
                              expression: "form.IsNecessary"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.FieldSurvey.Branches") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.FieldSurvey.surveyBranchId"),
                            error: _vm.$v.selectedBranch,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "BranchCommercialTitle",
                              url:
                                "VisionNextBranch/api/Branch/AutoCompleteSearch"
                            },
                            model: {
                              value: _vm.selectedBranch,
                              callback: function($$v) {
                                _vm.selectedBranch = $$v
                              },
                              expression: "selectedBranch"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addFieldSurveyBranchs($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.FieldSurveyBranchs
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-table-simple",
                            { attrs: { bordered: "", small: "" } },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.FieldSurvey.surveyBranchId"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.FieldSurveyBranchs != null
                                    ? _vm.form.FieldSurveyBranchs.filter(
                                        function(f) {
                                          return f.RecordState !== 4
                                        }
                                      )
                                    : [],
                                  function(r, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(
                                              r.SurveyBranch
                                                ? r.SurveyBranch.Label
                                                : r.Description1
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "far fa-trash-alt text-danger",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFieldSurveyBranchs(
                                                    r
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.FieldSurvey.employeeType") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.FieldSurvey.employeeType"),
                            error: _vm.$v.selectedEmployeeType,
                            required: true
                          }
                        },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Label",
                              filterable: false,
                              options: _vm.detailLookup.EMPLOYEE_TYPE
                            },
                            model: {
                              value: _vm.selectedEmployeeType,
                              callback: function($$v) {
                                _vm.selectedEmployeeType = $$v
                              },
                              expression: "selectedEmployeeType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addFieldSurveyEmployeeType(
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("insert.FieldSurvey.employeeType")
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(
                              _vm.form.FieldSurveyEmployeeTypes != null
                                ? _vm.form.FieldSurveyEmployeeTypes.filter(
                                    function(f) {
                                      return f.RecordState !== 4
                                    }
                                  )
                                : [],
                              function(r, i) {
                                return _c(
                                  "b-tr",
                                  { key: i },
                                  [
                                    _c("b-td", [
                                      _vm._v(
                                        _vm._s(
                                          r.EmployeeType
                                            ? r.EmployeeType.Label
                                            : r.Label
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-td", { staticClass: "text-center" }, [
                                      _c("i", {
                                        staticClass:
                                          "far fa-trash-alt text-danger",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFieldSurveyEmployee(
                                              r
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.FieldSurvey.questions") } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.FieldSurvey.questionId"),
                            error: _vm.$v.selectedQuestion.question,
                            required: true
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "Description1",
                              url:
                                "VisionNextFieldAnalysis/api/AnalysisQuestions/AutoCompleteSearch"
                            },
                            model: {
                              value: _vm.selectedQuestion.question,
                              callback: function($$v) {
                                _vm.$set(_vm.selectedQuestion, "question", $$v)
                              },
                              expression: "selectedQuestion.question"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.FieldSurvey.questionLineId"),
                            error: _vm.$v.selectedQuestion.lineNumber,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              maxLength: 4,
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value: _vm.selectedQuestion.lineNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedQuestion,
                                  "lineNumber",
                                  $$v
                                )
                              },
                              expression: "selectedQuestion.lineNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.FieldSurvey.questionIsNecessary"
                            ),
                            error: _vm.$v.selectedQuestion.isNecessary,
                            required: true
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.selectedQuestion.isNecessary,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedQuestion,
                                  "isNecessary",
                                  $$v
                                )
                              },
                              expression: "selectedQuestion.isNecessary"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addFieldSurveyQuestions($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.FieldSurveyQuestions
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.FieldSurvey.question"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.FieldSurvey.questionLine"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.FieldSurvey.questionIsNecessary"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("list.operations"))
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    _vm._l(
                                      _vm.form.FieldSurveyQuestions != null
                                        ? _vm.form.FieldSurveyQuestions.filter(
                                            function(f) {
                                              return f.RecordState !== 4
                                            }
                                          )
                                        : [],
                                      function(r, i) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.FieldSurvey
                                                    ? r.FieldSurvey.Label
                                                    : r.Description1
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(r.LineNumber))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _c("i", {
                                                class:
                                                  "" + r.IsNecessary == 1
                                                    ? "fas fa-check-square text-success"
                                                    : "fas fa-square text-danger"
                                              })
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "b-td",
                                              { staticClass: "text-center" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-trash-alt text-danger",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeFieldSurveyQuestions(
                                                        r
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.validDatesReq
                ? _c(
                    "b-tab",
                    {
                      attrs: { title: _vm.$t("insert.FieldSurvey.validDates") }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.fieldSurveyValidDates.description1"
                                ),
                                error: _vm.$v.selectedValidDates.description1,
                                required: true
                              }
                            },
                            [
                              _c("NextInput", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.selectedValidDates.description1,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedValidDates,
                                      "description1",
                                      $$v
                                    )
                                  },
                                  expression: "selectedValidDates.description1"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.fieldSurveyValidDates.startDate"
                                ),
                                error: _vm.$v.selectedValidDates.startDate,
                                required: true
                              }
                            },
                            [
                              _c("NextDatePicker", {
                                attrs: { size: "sm" },
                                model: {
                                  value: _vm.selectedValidDates.startDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedValidDates,
                                      "startDate",
                                      $$v
                                    )
                                  },
                                  expression: "selectedValidDates.startDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.fieldSurveyValidDates.endDate"
                                ),
                                error: _vm.$v.selectedValidDates.endDate,
                                required: true
                              }
                            },
                            [
                              _c("NextDatePicker", {
                                model: {
                                  value: _vm.selectedValidDates.endDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedValidDates,
                                      "endDate",
                                      $$v
                                    )
                                  },
                                  expression: "selectedValidDates.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.FieldSurvey.statusId"),
                                error: _vm.$v.selectedValidDates.statusId,
                                required: true
                              }
                            },
                            [
                              _c("NextCheckBox", {
                                attrs: { type: "number", toggle: "" },
                                model: {
                                  value: _vm.selectedValidDates.statusId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedValidDates,
                                      "statusId",
                                      $$v
                                    )
                                  },
                                  expression: "selectedValidDates.statusId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12", md: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addFieldSurveyValidDates(
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.FieldSurveyValidDates
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-table-simple",
                                    { attrs: { bordered: "", small: "" } },
                                    [
                                      _c(
                                        "b-thead",
                                        [
                                          _c(
                                            "b-th",
                                            { attrs: { width: "40%" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "insert.fieldSurveyValidDates.description1"
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("b-th", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.fieldSurveyValidDates.startDate"
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-th", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.fieldSurveyValidDates.endDate"
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-th", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "insert.fieldSurveyValidDates.statusId"
                                                  )
                                                )
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-th",
                                            { attrs: { width: "40px" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("list.operations")
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tbody",
                                        _vm._l(
                                          _vm.form.FieldSurveyValidDates != null
                                            ? _vm.form.FieldSurveyValidDates.filter(
                                                function(f) {
                                                  return f.RecordState !== 4
                                                }
                                              )
                                            : [],
                                          function(r, i) {
                                            return _c(
                                              "b-tr",
                                              { key: i },
                                              [
                                                _c("b-td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      r.FieldSurvey
                                                        ? r.FieldSurvey.Label
                                                        : r.Description1
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _vm._v(_vm._s(r.StartDate))
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _vm._v(_vm._s(r.EndDate))
                                                ]),
                                                _vm._v(" "),
                                                _c("b-td", [
                                                  _c("i", {
                                                    class:
                                                      "" + r.StatusId == 1
                                                        ? "fas fa-check-square text-success"
                                                        : "fas fa-square text-danger"
                                                  })
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "b-td",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "far fa-trash-alt text-danger",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeFieldSurveyValidDates(
                                                            r
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18eb85e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18eb85e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FieldSurvey/update.vue
// module id = null
// module chunks = 